import React, {useState} from "react";
import Button from '@mui/material/Button';
import SummarizeIcon from '@mui/icons-material/Summarize';
import CustomDialog from "../../../../../components/Dialog/DiaComp";
import { Lung_Variants_TableData } from "./Get_Lung_variants_table";

export default function Dia_Lung_Variants() {

    const [open, setOpen] = useState(false);
    const handleOpen = () => {setOpen(true);};
    const handleClose = () => {setOpen(false);};


return(
<>      
    <Button onClick={handleOpen} variant="text" sx={{ }}>
            <SummarizeIcon sx={{fontSize: '300%', color: 'tertiary.light', '&:hover': { color: 'primary.light'}, }} />
    </Button>

    <CustomDialog open={open} onClose={handleClose}

        title='Variants associated with lung cancer'

        content={ <Lung_Variants_TableData />}

        />


</>
)}